import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutPage from './screens/checkout';
import NotFoundPage from './screens/404';
import CheckoutSuccessPage from './screens/checkout/screens/CheckoutSuccessPage';

const stripePromise = loadStripe('pk_test_51Q2D1FIwOh90xS5rbxtRJQbVNAI96D6qDzeCcyqiv3m0RzSYX4xd19tGr32abDJjENt9ZaLizaZhioaTtYCgS4CD00KorNW6oU');

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route
            path=":slug"
            element={<Navigate to=":slug/checkout" replace />}
          />
          <Route path=":slug/checkout" element={<CheckoutPage stripePromise={stripePromise} />} />
          <Route path=":slug/checkout/success/:externalId" element={<CheckoutSuccessPage stripePromise={stripePromise} />} />
          {/* <Route path="user/resetPassword" element={<ResetPasswordPage />} />
          <Route path="user/setPassword/:token" element={<SetPasswordPage />} /> */}
          <Route
            path="*"
            element={<NotFoundPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default observer(Router);
